import React, { Fragment } from 'react';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
import { Fade } from '@mui/material';

// *******************************************************
// RAIL COMPONENT
// *******************************************************
const RailOuter = styled('div')({
  position: 'absolute',
  width: '100%',
  transform: 'translate(0%, -50%)',
  height: 42,
  borderRadius: 21,
  cursor: 'pointer'
});

const RailInner = styled('div')({
  position: 'absolute',
  width: '100%',
  transform: 'translate(0%, -50%)',
  height: 4,
  borderRadius: 2,
  pointerEvents: 'none',
  backgroundColor: 'rgb(155,155,155)',
});

export const SliderRail = ({ getRailProps }) => (
  <Fragment>
    <RailOuter {...getRailProps()} />
    <RailInner />
  </Fragment>
);

// *******************************************************
// HANDLE COMPONENT
// *******************************************************
const HandleOuter = styled('div')({
  position: 'absolute',
  WebkitTapHighlightColor: 'rgba(0,0,0,0)',
  zIndex: 5,
  width: 20,
  height: 40,
  transform: 'translate(-50%, -50%)',
  cursor: 'pointer',
  backgroundColor: 'none',
});

const HandleInner = styled('div', {
  shouldForwardProp: (prop) => prop !== 'active',
})(({ theme, active }) => ({
  position: 'absolute',
  WebkitTapHighlightColor: 'rgba(0,0,0,0)',
  zIndex: 2,
  width: 12,
  height: 12,
  transform: 'translate(-50%, -50%)',
  borderRadius: '50%',
  backgroundColor: theme.palette.primary.main,
  ...(active && {
    boxShadow: `0px 0px 0px 16px ${Fade(theme.palette.primary.main, 0.16)}`,
  }),
}));

export const Handle = ({
  domain: [min, max],
  handle: { id, value, percent },
  activeHandleID,
  getHandleProps,
}) => {
  const active = activeHandleID === id;

  return (
    <Fragment>
      <HandleOuter
        style={{ left: `${percent}%` }}
        {...getHandleProps(id)}
      />
      <HandleInner
        role="slider"
        aria-valuemin={min}
        aria-valuemax={max}
        aria-valuenow={value}
        active={active}
        style={{ left: `${percent}%` }}
      />
    </Fragment>
  );
};

// *******************************************************
// TRACK COMPONENT
// *******************************************************
const TrackRoot = styled('div')(({ theme }) => ({
  position: 'absolute',
  transform: 'translate(0%, -50%)',
  height: 4,
  zIndex: 1,
  borderRadius: 2,
  cursor: 'pointer',
  backgroundColor: theme.palette.primary.dark,
}));

export const Track = ({ source, target, getTrackProps }) => {
  return (
    <TrackRoot
      style={{
        left: `${source.percent}%`,
        width: `${target.percent - source.percent}%`,
      }}
      {...getTrackProps()}
    />
  );
};

// *******************************************************
// TICK COMPONENT
// *******************************************************
const TickMark = styled('div')(({ theme }) => ({
  position: 'absolute',
  marginTop: 10,
  width: 1,
  height: 5,
  backgroundColor: theme.palette.text.primary,
}));

const TickLabel = styled(Typography)({
  position: 'absolute',
  marginTop: 16,
  textAlign: 'center',
});

export const Tick = ({ tick, count, format = d => d }) => {
  return (
    <div>
      <TickMark style={{ left: `${tick.percent}%` }} />
      <TickLabel
        variant="caption"
        style={{
          marginLeft: `${-(100 / count) / 2}%`,
          width: `${100 / count}%`,
          left: `${tick.percent}%`,
        }}
      >
        {format(tick.value)}
      </TickLabel>
    </div>
  );
};
